import React from 'react'
import { Link } from 'gatsby'

const Pagination = ({ currentPage, pagesTotal, getPageUrl }) => {
  let nextPage
  let prevPage

  if (currentPage > 1) {
    prevPage = (
      <Link className="prev-page" disabled to={getPageUrl(currentPage - 1)}>
        ❮ 上一页
      </Link>
    )
  } else {
    prevPage = <div className="info">第一页</div>
  }

  if (currentPage < pagesTotal) {
    nextPage = (
      <Link className="next-page" to={getPageUrl(currentPage + 1)}>
        下一页 ❯
      </Link>
    )
  }

  const pagesLabel = (
    <div className="info">{`当前 ${currentPage}/${pagesTotal}`}</div>
  )

  return (
    <div className="pagination">
      {prevPage}
      {pagesLabel}
      {nextPage}
    </div>
  )
}

export default Pagination
